import React from 'react';

import classNames from 'classnames/bind';
import style from './SocialSharing.scss';
const ctx = classNames.bind(style);

import SocialSharing from '../../../SocialSharing';

class SocialSharingWrap extends React.Component {
  render() {
    return (
      <div className={ctx('social-sharing')}>
        <div className={ctx('title')}>ПОДЕЛИТЬСЯ СТАТЬЕЙ</div>
        <SocialSharing />
      </div>
    );
  }
}

export default SocialSharingWrap;
